import { createReducer } from "reduxsauce"
import createActions from "helpers/actionCreator"
import { Types as LoaderTypes } from "model/data"
import { takeLatest, put, select } from "redux-saga/effects"
import { findIndex } from "lodash"
import { getUserPreference } from "helpers/userPreferences"
import { Creators as PreferencesCreators } from "model/preferences"
import { getModels } from "resources/models"

export const { Types, Creators } = createActions("ompnt/modules/watchlist-root/", {
  setDate: ["date"],
  setModel: {
    props: ["modelId"],
    updatePreference: {
      getItems: (state, { modelId }) => [{
        type: "watchlistLastModelUsed",
        value: modelId,
      }],
    },
  },
  loadWatchlistSuccess: ["modelId"],
})

const DEFAULT_STATE = {
  selectedDate: null,
  selectedModel: null,
}

function handleLoadWatchlistSuccess(state, { modelId }) {
  return { ...state, selectedModel: modelId }
}

function handleSetDate(state, { date }) {
  return { ...state, selectedDate: date }
}

function handleSetModel(state, { modelId }) {
  return { ...state, selectedModel: modelId }
}

export default createReducer(DEFAULT_STATE, {
  [Types.LOAD_WATCHLIST_SUCCESS]: handleLoadWatchlistSuccess,
  [Types.SET_DATE]: handleSetDate,
  [Types.SET_MODEL]: handleSetModel,
})

function* handleLoadSuccess({ resource, data }) {
  if (resource === "watchlistRootPreferences") {
    const { accountId, selectedModel, models } = yield select(state => ({
      accountId: state.global.selected.accountId,
      selectedModel: state.modules.watchlistRoot.selectedModel,
      models: getModels(state),
    }))

    let modelId = selectedModel
    if (!modelId) {
      modelId = getUserPreference(data, "watchlistLastModelUsed", null)
    }

    // In case the user does not have access to this model anymore.
    if (modelId && findIndex(models, { id: modelId }) === -1) {
      modelId = null
      yield put(PreferencesCreators.deletePreferences([{ type: "watchlistLastModelUsed", accountId }]))
    }

    yield put(Creators.loadWatchlistSuccess(modelId))
  }
}

export function* saga() {
  yield takeLatest(LoaderTypes.LOAD_SUCCESS, handleLoadSuccess)
}
